import { Box } from "@mui/material";
import { ICLoading } from "../Icon/ICLoading";

interface SpinnerLoadingProps {
  className?: string;
  size?: number;
  logoClassName?: string;
}

export default function SpinnerLoading({
  className,
  size = 100,
  logoClassName,
}: SpinnerLoadingProps) {
  return (
    <Box
      className={className}
      sx={{
        position: "relative",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: size,
        height: size,
      }}
    >
      <svg
        width={size}
        height={size}
        viewBox="0 0 80 80"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{
          position: "absolute",
          animation: "spin 2s linear infinite",
        }}
      >
        <g
          clipPath="url(#paint0_angular_336_16937_clip_path)"
          data-figma-skip-parse="true"
        >
          <g transform="matrix(0 0.04 -0.04 0 40 40)">
            <foreignObject x="-1025" y="-1025" width="2050" height="2050">
              <div
                style={{
                  background:
                    "conic-gradient(from 90deg, rgba(25, 171, 74, 1) 0deg, rgba(25, 171, 74, 0) 360deg)",
                  height: "100%",
                  width: "100%",
                  opacity: 1,
                }}
              ></div>
            </foreignObject>
          </g>
        </g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80ZM40 72C57.6731 72 72 57.6731 72 40C72 22.3269 57.6731 8 40 8C22.3269 8 8 22.3269 8 40C8 57.6731 22.3269 72 40 72Z"
        />
        <defs>
          <clipPath id="paint0_angular_336_16937_clip_path">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80ZM40 72C57.6731 72 72 57.6731 72 40C72 22.3269 57.6731 8 40 8C22.3269 8 8 22.3269 8 40C8 57.6731 22.3269 72 40 72Z"
            />
          </clipPath>
        </defs>
      </svg>

      {/* Center logo */}
      <Box
        className={logoClassName}
        sx={{
          position: "relative",
          zIndex: 10,
        }}
      >
        <ICLoading width={`${size * 0.4}`} height={`${size * 0.4}`} />
      </Box>

      {/* CSS Animation for the spinner */}
      <Box
        sx={{
          "@keyframes spin": {
            "0%": {
              transform: "rotate(360deg)",
            },
            "100%": {
              transform: "rotate(0deg)",
            },
          },
        }}
        component="span"
      />
    </Box>
  );
}
